/* eslint-disable max-len */
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { RENTAL_FILES } from '../apiUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import rentalFilesFields from '../../fields/rentalFilesFields';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';

/**
 * @param responseData response.data object
 * @param responseData.items array
 * @param responseData.totalResults number
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [rentalFilesFields.UUID.key]: item[rentalFilesFields.UUID.key],
            [rentalFilesFields.FILE_NUMBER.key]: item[rentalFilesFields.FILE_NUMBER.key],
            [rentalFilesFields.POS_TERMINAL.key]: {
                [rentalFilesFields.POS_TERMINAL.LABEL.key]:
                    getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(rentalFilesFields.POS_TERMINAL.LABEL))
            },
            [rentalFilesFields.OPENING_DATE.key]: item[rentalFilesFields.OPENING_DATE.key],
            [rentalFilesFields.CLOSING_DATE.key]: item[rentalFilesFields.CLOSING_DATE.key],
            [rentalFilesFields.STATUS.key]: item[rentalFilesFields.STATUS.key],
            [rentalFilesFields.TOTAL_AMOUNT.key]: item[rentalFilesFields.TOTAL_AMOUNT.key],
            [rentalFilesFields.EXPIRATION_DATE.key]: item[rentalFilesFields.EXPIRATION_DATE.key],
            [rentalFilesFields.CURRENCY.key]: item[rentalFilesFields.CURRENCY.key],
            [rentalFilesFields.BANK_CODE.key]: item[rentalFilesFields.BANK_CODE.key],
            [rentalFilesFields.PAN.key]: item[rentalFilesFields.PAN.key],
            [rentalFilesFields.CARD_DETAILS.key]: {
                [rentalFilesFields.CARD_DETAILS.TYPE.key]:
                    getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(rentalFilesFields.CARD_DETAILS.TYPE)),
                [rentalFilesFields.CARD_DETAILS.PRODUCT.key]:
                    getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(rentalFilesFields.CARD_DETAILS.PRODUCT))
            }
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetRentalFiles = (query, enabled, remoteCollectionId) => {
    return {
        queryKey: [RENTAL_FILES.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(RENTAL_FILES.COLLECTION.url, { remoteCollectionsId: remoteCollectionId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetRentalFiles;